import React from 'react';

import useIsMobile from 'utils/useIsMobile';

import styles from './style.module.scss';

const PageHeader = ({ header, description, methodType }) => {
  const isMobile = useIsMobile();

  return (
    <div>
      <div className={styles.headerContainer}>
        <div className={styles.title}>
          <p className={styles.submenuIcon}>
            {(methodType === 'GET' && 'GET') ||
              (methodType === 'POST' && 'POST') ||
              (methodType === 'PUT' && 'PUT')}
          </p>
          <h1 className={isMobile ? `${styles.headerMobile}` : ''}>{header}</h1>
        </div>
        <div className={styles.description}>
          {description &&
            (description.includes('\\n')
              ? description
                  .split('\\n')
                  .map(line => <p key={`line-${line}`}>{line}</p>)
              : description)}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
